import http from '../../services/http-common';
import securityService from '../../components/security/security.service';

class PropertyOwnerService {
  getPropertyOwnerForList() {
    let queryParams = new URLSearchParams({CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
    return http.get(`/PropertyOwner/db/table?${queryParams}`);
  }
  insert(data) {
    return http.post(`/PropertyOwner/db/add`, data);
  }
  update(data) {
    return http.put(`/PropertyOwner/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/PropertyOwner/db/delete/${PropertyID}`);
  }
}

export default new PropertyOwnerService();